import React, { useState } from 'react';
import '../styles/components/FechaSelector.css';
const FechaSelector = ({ onDateChange }) => {
  const [mes, setMes] = useState('');
  const [anual, setAnual] = useState('');

  const handleMesChange = (e) => {
    const selectedMes = e.target.value;
    setMes(selectedMes);
    onDateChange(selectedMes, anual);
  };

  const handleAnualChange = (e) => {
    const selectedAnual = e.target.value;
    setAnual(selectedAnual);
    onDateChange(mes, selectedAnual);
  };

  

  return (
    <div>
      
      <select value={mes} onChange={handleMesChange}>
        <option value="">Selecciona un mes</option>
        {[...Array(12)].map((_, i) => (
          <option key={i + 1} value={i + 1}>{i + 1}</option>
        ))}
      </select>

      
      <select value={anual} onChange={handleAnualChange}>
        <option value="">Selecciona un año</option>
        {[...Array(5)].map((_, i) => (
          <option key={i} value={2023 + i}>{2023 + i}</option>
        ))}
      </select>
    </div>
  );
};

export default FechaSelector;
